<template>
  <div class="h-px w-full bg-neutral-200" />
</template>
